import axios from 'axios';
import authHeader from '../auth-header';

import baseUrl from '../base-url';

const API_URL = baseUrl() + "/api/web-view/";
const petaSebaran = 'data-test-center-statistik';

class LocationTCService {    
    getPetaSebaran() {
        return axios.get(
            API_URL + petaSebaran ,
            {
                
                headers: authHeader()
            }
        );
    }
    
}

export default new LocationTCService();
